import { useState } from 'react';
import { Button } from '../../../components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../../../components/ui/dialog';
import { Label } from '../../../components/ui/label';
import { Textarea } from '../../../components/ui/textarea';

const NOTE_MAX_LENGTH = 512;

export interface RecordBrandCounterDialogProps {
  open: boolean;
  name: string;
  onSubmit: (note?: string) => void;
  onCancel: () => void;
}

export function RecordBrandCounterDialog({ open, name, onSubmit, onCancel }: RecordBrandCounterDialogProps) {
  const [note, setNote] = useState('');
  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!next) onCancel();
      }}
    >
      <DialogContent className="max-w-[calc(100%-2rem)] sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Record brand counter</DialogTitle>
          <DialogDescription>{`The brand wants a lower rate for ${name}. Note what they said in the roster chat — the row will read "Brand asked for less".`}</DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-1.5">
          <Label htmlFor="brand-counter-note">What did the brand say?</Label>
          <Textarea id="brand-counter-note" rows={3} maxLength={NOTE_MAX_LENGTH} value={note} onChange={(e) => setNote(e.target.value)} placeholder="e.g. They can do ₹30,000 for the reel" />
        </div>
        <div className="flex items-center justify-end gap-2">
          <Button type="button" variant="outline" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="button" onClick={() => onSubmit(note.trim() || undefined)}>
            Record
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
